import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PolygonArrow from "assets/images/Polygon 1.svg";
import { useDispatch, useSelector } from "react-redux";
import { pet } from "redux-store/pets/pet.selector";
import { getUserPets, errorClean } from "redux-store/pets/pet.slice";
import { AppDispatch } from "redux-store/store";

type Propstype = {
  changeStep?: any;
  setKitData?: any;
  kitData?: any;
};

const StepOne = ({ changeStep, setKitData, kitData }: Propstype) => {
  const [petId, setPetId] = useState("");
  const [showError, setShowError] = useState(false);
  const pets = useSelector(pet);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(errorClean());
    // dispatch(getUserPets());
  }, []);

  const handleClick = (e: any) => {
    if (petId) {
      setShowError(false);
      changeStep("step2");
    } else {
      setShowError(true);
    }
  };

  const handleChange = (e: any) => {
    setPetId(e.target.value);
    setKitData({ ...kitData, [e.target.name]: e.target.value });
  };

  return (
    //   main col
    <div className="tw-flex tw-flex-col tw-gap-6">
      {/* 1st item */}
      <div className="tw-flex tw-flex-col tw-gap-2">
        <p className="tw-font-medium tw-text-[1rem] lg:tw-text-[1.625rem]">
          Create Your Pet
        </p>
        <p className="tw-text-[0.75rem] lg:tw-text-[1.125rem] tw-font-light tw-text-[#6C6C6C]">
          This won’t take long at all. We need to know which pet you are
          testing. If you haven’t added a pet yet, please click “Add New Pet”
          link below
        </p>
      </div>
      {/* 2nd item */}
      <div className="tw-flex tw-flex-col tw-gap-4">
        <p className="tw-font-bold tw-text-[1rem] lg:tw-text-[1.625rem]">
          My Pets
        </p>
        <div className="tw-w-[70%] tw-flex tw-items-center tw-relative">
          <select
            className="tw-w-full lg:tw-w-[38%] tw-py-2 lg:tw-py-4 tw-pl-2 lg:tw-pl-2 tw-relative tw-z-10 tw-appearance-none tw-bg-transparent tw-border-[1px] lg:tw-border-2 tw-border-[#ABABAB] tw-rounded-lg tw-text-[#ABABAB] tw-text-[0.75rem] lg:tw-text-[1.25rem] focus:tw-outline-none "
            onChange={handleChange}
            required
            name="petId"
          >
            <option selected disabled>
              Choose Your Pet
            </option>
            {pets?.length !== 0 &&
              pets &&
              pets.map((pet, i) => (
                <option key={i} value={pet._id}>
                  {pet?.petName ? pet?.petName : "No Name"}
                </option>
              ))}
          </select>
          <img
            src={PolygonArrow}
            className="tw-absolute tw-w-[1rem] lg:tw-w-fit tw-right-[5%] lg:tw-left-[30%] tw-text-[0.75rem] lg:tw-text-[1.25rem] tw-z-0"
            alt="arrow"
          />
        </div>

        {showError && (
          <p className="  tw-text-darkRed tw-text-[1.125rem] ">
            Please select a pet name
          </p>
        )}
        <div className="tw-text-[0.75rem] lg:tw-text-[1.125rem] ">
          <span className="tw-text-[#6C6C6C]">
            Don’t see your pet in the list above?
          </span>
          <span className="tw-font-bold tw-ml-1 tw-text-[#8750A4]">
            <Link to="/user/pets/edit-pet-details/add">Add New Pet</Link>
          </span>
        </div>
      </div>
      {/* 3rd item */}
      <div className="tw-w-[25%] lg:tw-w-[13%] tw-font-bold tw-text-[0.875rem] lg:tw-text-[1.25rem]">
        <button
          className="tw-w-full tw-flex tw-items-center tw-justify-center tw-py-1 lg:tw-py-2 tw-rounded-[10px] tw-border-[1px] lg:tw-border-[2px] tw-border-[#FF503D]"
          onClick={handleClick}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default StepOne;
